import AccountIcon from 'src/assets/icons/fi-rr-building.svg';
import { FieldMappingsMockUpType } from '../types';

export const selectedData = {
  value: '',
  to_crm_if_blank: true,
  from_sprouts: false,
  nosync: false,
  // crm to sproutes
  toSprouts: true,
  dontSyncToSprouts: false,
};

export const CompanyFieldMappings: FieldMappingsMockUpType = {
  id: 'company',
  label: 'Account',
  testRunId: 'companies',
  testRunLabel: 'Accounts',
  icon: AccountIcon,
  desc: 'Fields mapped',
  count: '0',
  entity: 'Companies',
  sproutsFields: [
    {
      label: 'Domain',
      id: 'domain',
      fieldType: 'String',
      selectedData,
      required: true,
    },
    {
      label: 'Account Name',
      id: 'name',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Intent Score',
      id: 'intentCount',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object', 'Integer', 'Long', 'Double'],
      onlyOutbound: true,
    },
    {
      label: 'Intent Topics',
      id: 'intentTopics',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      onlyOutbound: true,
    },
    {
      label: 'AI News',
      selectedData,
      id: 'aiNews',
      fieldType: 'String',
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      featureFlag: 'aiNews',
      onlyOutbound: true,
    },
    {
      label: 'AI News Source Url',
      selectedData,
      id: 'aiNewsSourceUrl',
      fieldType: 'String',
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      featureFlag: 'aiNews',
      onlyOutbound: true,
    },
    {
      label: 'Awards And Recognitions',
      selectedData,
      id: 'awardAndRecognition',
      fieldType: 'String',
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      featureFlag: 'awardsAndRecognition',
      onlyOutbound: true,
    },
    {
      label: 'Awards And Recognitions Source Url',
      selectedData,
      id: 'awardAndRecognitionSourceUrl',
      fieldType: 'String',
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      featureFlag: 'awardsAndRecognition',
      onlyOutbound: true,
    },
    {
      label: 'Recent Funding',
      selectedData,
      id: 'recentFundingResponse',
      fieldType: 'String',
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      featureFlag: 'recentFunding',
      onlyOutbound: true,
    },
    {
      label: 'Recent Funding Source Url',
      selectedData,
      id: 'recentFundingSourceUrl',
      fieldType: 'String',
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      featureFlag: 'recentFunding',
      onlyOutbound: true,
    },
    {
      label: 'Industry',
      id: 'industry',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      onlyOutbound: true,
    },
    {
      label: 'Region',
      id: 'companyRegion',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Total Funding Amount',
      id: 'totalFundingAmountNumeric',
      fieldType: 'Long',
      selectedData,
    },
    {
      label: 'Latest Funding Amount',
      id: 'latestFundingAmountNumeric',
      fieldType: 'Long',
      selectedData,
    },
    {
      label: 'Latest Funding Stage',
      id: 'latestFundingStage',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Latest Funding Date',
      id: 'latestFundingDate',
      fieldType: 'Date',
      selectedData,
    },
    {
      label: 'B2B/B2C',
      id: 'b2b_B2c',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      onlyOutbound: true,
    },
    {
      label: 'Govt/Non-Govt',
      id: 'govtNonGovt',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      onlyOutbound: true,
    },
    {
      label: 'Profit/Non-Profit',
      id: 'profitNonProfit',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      onlyOutbound: true,
    },
    {
      label: 'Product/Service',
      id: 'productService',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      onlyOutbound: true,
    },
    {
      label: 'Founded Year',
      id: 'FoundedYear',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      onlyOutbound: true,
    },
    {
      label: 'Account Owner',
      id: 'email',
      fieldType: 'String',
      selectedData,
      testValue: 'email',
      supportedTypes: ['String', 'Set', 'List', 'Object'],
    },
    // {
    //   label: 'Address',
    //   id: 'address',
    //   fieldType: 'String',
    //   selectedData,
    // },
    {
      label: 'Phone Number',
      id: 'phoneNo',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'HQ Phone Number',
      id: 'hqPhoneNumber',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Account Status',
      id: 'leadStatus',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
    },
    {
      label: 'Total Visits',
      id: 'noOfHits',
      fieldType: 'Long',
      selectedData,
    },
    {
      label: 'Last Visited Date',
      id: 'lastVisitedTime',
      fieldType: 'Date',
      selectedData,
    },
    {
      label: 'Lifecycle Stage',
      id: 'lifecycleStage',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      extraInfo: {
        label: 'Necessary for ICP scoring',
        tooltipTitle: 'Mandatory for Account ICP scores',
        tooltipDescription:
          'This field is essential to understand your current ICP and generate Account ICP scores',
      },
    },
    {
      label: 'Employee Count Range',
      id: 'noOfEmployeeRange',
      fieldType: 'Integer',
      selectedData,
      onlyOutbound: true,
    },
    {
      label: 'Website',
      id: 'website',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Linkedin Url',
      id: 'companyLinkedin',
      fieldType: 'String',
      selectedData,
    },
    // {
    //   label: 'Twitter Url',
    //   id: 'twitterurl',
    //   fieldType: 'String',
    //   selectedData,
    // },
    {
      label: 'Facebook Url',
      id: 'facebookUrl',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Job Openings',
      id: 'jobOpenings',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Annual Revenue',
      id: 'annualrevenue',
      fieldType: 'Long',
      selectedData,
      testValue: 'annualRevenue',
    },
    {
      label: 'Company HQ',
      id: 'companyHq',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Technologies',
      id: 'technologies',
      fieldType: 'String',
      typeId: 'companyTechnologies',
      selectedData,
      onlyOutbound: true,
    },
    {
      label: 'Country',
      id: 'country',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
    },
    {
      label: 'City',
      id: 'city',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'State',
      id: 'state',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Sprouts Recommended ICP',
      id: 'icpFitmentScore',
      fieldType: 'String',
      selectedData,
      featureFlag: 'icpScoring',
      isAiField: true,
      onlyOutbound: true,
    },
    {
      label: 'ICP AI Summary',
      id: 'icpContributingFactors',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      onlyOutbound: true,
    },
    {
      label: 'Account SDR Owner',
      id: 'sdrOwnerEmail',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'List Name',
      id: 'tagName',
      fieldType: 'String',
      selectedData,
      onlyOutbound: true,
    },
    {
      label: 'Employee Count (Min)',
      id: 'noOfEmployeeMin',
      fieldType: 'Integer',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Integer', 'Long'],
    },
    {
      label: 'Employee Count (Max)',
      id: 'noOfEmployeeMax',
      fieldType: 'Integer',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Integer', 'Long'],
    },
    {
      label: 'Source',
      id: 'source',
      fieldType: 'String',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
    },
    {
      label: 'Added on Sprouts',
      id: 'insertedAt',
      fieldType: 'Date',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Set', 'List', 'Object', 'Date'],
    },
    {
      label: 'Updated At Sprouts',
      id: 'updatedAt',
      fieldType: 'Date',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Set', 'List', 'Object', 'Date'],
    },
    {
      label: 'Account Source File',
      id: 'uploadFileName',
      fieldType: 'String',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
    },
    // {
    //   label: 'Technology',
    //   id: 'techStack',
    //   selectedData,
    //   onlyOutbound: true,
    //   supportedTypes: ['String', 'Set', 'List', 'Object'],
    // },
  ],
};
